export default __webpack_public_path__ + "static/media/blue.4592156a.svg";